import React from "react";
import { styled } from "@mui/material/styles";
import ReactMarkdown from "react-markdown";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Divider,
  Drawer,
  Paper,
  Toolbar,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import { GeneralTaskDetails } from "../../views/GeneralTask/generalTask.types";
import KeyValueListTable from "../common/KeyValueListTable";
import { sweepsList } from "../../views/GeneralTask/generalTask.service";

const StyledDrawer = styled(Drawer)(() => ({
  width: "25vw",
  padding: 10,
}));

const StyledDrawerPaper = styled(Paper)(() => ({
  width: "25vw",
  padding: 10,
}));

const StyledDetailsContainer = styled("div")(() => ({
  paddingTop: 20,
}));

const StyledArgumentsContainer = styled("div")(() => ({
  paddingTop: 20,
}));

interface GeneralTaskDetailDrawerProps {
  openDrawer: boolean;
  generalTaskDetails: GeneralTaskDetails;
}
const GeneralTaskDetailDrawer: React.FC<GeneralTaskDetailDrawerProps> = ({
  openDrawer,
  generalTaskDetails,
}: GeneralTaskDetailDrawerProps) => {
  const sweepArguments = sweepsList(
    generalTaskDetails?.argument_lists ?? [],
    generalTaskDetails?.swept_arguments || [],
  );

  return (
    <StyledDrawer anchor={"right"} variant="persistent" open={openDrawer}>
      <StyledDrawerPaper elevation={0}>
        <Toolbar />{" "}
        <Typography variant="h5" gutterBottom>
          General Task: {generalTaskDetails?.title}
        </Typography>
        <Divider />
        <StyledDetailsContainer>
          <Typography>
            <strong>Id:</strong> {generalTaskDetails?.id}
          </Typography>
          <Typography>
            <strong>Model type:</strong> {generalTaskDetails?.model_type}
          </Typography>
          <Typography>
            <strong>Created: </strong> {generalTaskDetails?.created}
          </Typography>
          {generalTaskDetails?.description && (
            <>
              <Typography>
                <strong>Description:</strong>
              </Typography>
              <ReactMarkdown>{generalTaskDetails?.description ?? ""}</ReactMarkdown>
            </>
          )}
          {generalTaskDetails?.notes && (
            <span>
              <Typography>
                <strong>Notes:</strong>
              </Typography>
              <ReactMarkdown>{generalTaskDetails?.notes}</ReactMarkdown>
            </span>
          )}
          <StyledArgumentsContainer>
            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography>
                  <strong>Swept Arguments</strong>
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                {generalTaskDetails?.argument_lists && <KeyValueListTable header={null} data={sweepArguments} />}
              </AccordionDetails>
            </Accordion>

            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography>
                  <strong>All Arguments</strong>
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                {generalTaskDetails?.argument_lists && (
                  <KeyValueListTable header={null} data={generalTaskDetails?.argument_lists} />
                )}
              </AccordionDetails>
            </Accordion>
          </StyledArgumentsContainer>
        </StyledDetailsContainer>{" "}
      </StyledDrawerPaper>
    </StyledDrawer>
  );
};

export default GeneralTaskDetailDrawer;
